import { motion } from "framer-motion";
import { Heart, WheelchairMotion, CreditCard } from "@phosphor-icons/react";

export default function AboutUs() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-card">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="rounded-xl overflow-hidden border border-stone-200">
              <img
                src="https://images.pexels.com/photos/4489794/pexels-photo-4489794.jpeg"
                alt="Mobile Mechanic PDX Professional"
                className="w-full h-[400px] lg:h-[520px] object-cover"
                loading="lazy"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-4 md:right-6 bg-background border border-stone-200 rounded-xl p-5 shadow-sm">
              <p className="font-heading font-extrabold text-3xl text-primary tracking-tight">4.9</p>
              <p className="text-xs text-muted-foreground font-medium mt-1">Star Rating</p>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <p className="uppercase text-xs tracking-[0.2em] text-muted-foreground font-medium mb-4">
              Expert at Your Door
            </p>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-none mb-6">
              Skip the tow.
              <br />
              <span className="text-primary">We come to you.</span>
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-6 text-sm md:text-base font-medium">
              Mobile Mechanic PDX is a premier on-site automotive repair service in Portland, designed for customers who prioritize convenience without sacrificing mechanical quality.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-8 text-sm md:text-base">
              By bringing the shop to your driveway, we eliminate the need for costly towing and time-consuming waiting rooms. Our professional expertise is delivered directly to you, whether you're at home, at work, or anywhere in the NW Portland and Bethany areas.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="flex items-start gap-3 p-4 bg-background rounded-xl border border-stone-200" data-testid="about-feature-pdx">
                <Heart weight="duotone" className="w-5 h-5 text-primary mt-0.5 shrink-0" />
                <div>
                  <p className="font-heading font-bold text-sm">Portland Local</p>
                  <p className="text-xs text-muted-foreground mt-1">Serving NW Portland & Bethany</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-background rounded-xl border border-stone-200" data-testid="about-feature-mobile">
                <WheelchairMotion weight="duotone" className="w-5 h-5 text-primary mt-0.5 shrink-0" />
                <div>
                  <p className="font-heading font-bold text-sm">Mobile First</p>
                  <p className="text-xs text-muted-foreground mt-1">ASE-style expertise at your door</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-background rounded-xl border border-stone-200" data-testid="about-feature-modern">
                <CreditCard weight="duotone" className="w-5 h-5 text-primary mt-0.5 shrink-0" />
                <div>
                  <p className="font-heading font-bold text-sm">Modern Pay</p>
                  <p className="text-xs text-muted-foreground mt-1">Easy, upfront digital estimates</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
